import React from "react";
import RightServiceInstaImgSection2 from "./RightServiceInstaImgSection2";

import insta1 from "../../../../images/aboutimage/insta1.jpg";
import insta2 from "../../../../images/aboutimage/insta2.jpg";
import insta3 from "../../../../images/aboutimage/insta3.jpg";
import insta4 from "../../../../images/aboutimage/insta4.jpg";
import insta5 from "../../../../images/aboutimage/insta5.jpg";
import insta6 from "../../../../images/aboutimage/insta6.jpg";
const RightServiceInstaSection2 = (props) => {
  if (props.row === "top") {
    return (
      <div className="tri  flex cursor-pointer justify-around mt-10">
        <RightServiceInstaImgSection2 image={insta1} />
        <RightServiceInstaImgSection2 image={insta4} />
        <RightServiceInstaImgSection2 image={insta3} />
      </div>
    );
  } else {
    return (
      <div className="tri flex cursor-pointer justify-around mt-10">
        <RightServiceInstaImgSection2 image={insta2} />
        <RightServiceInstaImgSection2 image={insta5} />
        <RightServiceInstaImgSection2 image={insta6} />
      </div>
    );
  }
};
export default RightServiceInstaSection2;
